import { Text, TextVariants } from "@next-platform/client-common-spicy-ui";
import React from "react";

const DEFAULT_TEST_ID = "DiscoverRowHeader";

type DiscoverRowHeaderProps = {
  title: string;
  "data-testid"?: string;
};

const DiscoverRowHeader = ({ title, "data-testid": testId = DEFAULT_TEST_ID }: DiscoverRowHeaderProps) => {
  return (
    <Text data-testid={testId} variant={TextVariants.HEADING_5_BOLD} as="h2" className="my-0">
      {title}
    </Text>
  );
};

export default React.memo(DiscoverRowHeader);
